import { useAliyunOssUpload } from '@/utils/aliyunOss'
import OSS from 'ali-oss'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'
import BasicLayout from '../components/basic-layout/index.vue'
import ToolTip from '../components/tool-tip'
import AssessmentTrackMixin from '../mixins/assessment-track-mixin'
import RouterMixin from '../mixins/router-mixin'

import {
  getBaseInfo,
  getExamInfo,
  getExamStatus,
  getOssToken,
  getPublishEdit,
  postPublishEdit,
  publishAssessment,

} from '../model/api'
import {
  COlUMNS,
  labelCol,
  LEVEL_1,
  LEVEL_2,
  LEVEL_3,
  rangepicker,
  SUBJECT_TYPE_LIST,
  wrapperCol
} from './../model/publish'

const { getMd5, uploadAliyunOss } = useAliyunOssUpload()
const prefix = 'https://cdn-tiku.17zuoye.cn/'
const dateFormat = 'YYYY-MM-DD HH:mm'
const baseUri = ''
const examType = 'unify'
@Component({
  components: { BasicLayout, ToolTip, VueCtkDateTimePicker }
})
export default class AssessmentPublish extends Mixins(RouterMixin, AssessmentTrackMixin) {
  public testTime = ''
  public form: any = {
    // 测试名称，没有的情况下默认取试卷的名称，
    examName: '',
    // 测试类型
    examType: 'UNIT_TEST',
    // 年级
    clazzLevel: '',
    shool: '',
    range: [],
    examStartTime: '',
    examEndTime: '',
    // 口语重复次数
    oralRepeatCount: 1,
    // 成绩发布时间
    resultIssueTime: '',
    // 考试时长
    durationMinutes: '',
    // 批改时间
    correctStopTime: '',
    // 试卷信息
    paperInfo: {},
    // 是否已发布 ONLINE/RAW RAW
    status: '',
    // 是否允许查看成绩
    studentVisible: 1,
    // 成绩类型 0分数 1第等
    gradeType: 0,
    ranks: [],
    subjectTypes: [],
    // 上传文档地址
    paperUrl: this.address,
    // 上传文档名称
    fileName: this.fileName,
    // 对应考务状态
    newExamStatus:''
  }
  public rules = {
    examName: [{ required: true, message: `${this.titleText}名称不能为空`, trigger: 'blur' }],
    examType: [{ required: true, message: `请选择${this.titleText}类型`, trigger: 'blur' }],
    range: [
      {
        required: true,
        validator: this.checkDateRange,
        trigger: ['change', 'blur']
      }
    ],
    resultIssueTime: [
      { required: true, validator: this.checkPublishTime, trigger: ['change', 'blur'] }
    ],
    correctStopTime: [
      {
        required: true,
        validator: this.checkCorrectTime,
        trigger: ['change', 'blur']
      }
    ],
    durationMinutes: [
      { required: true, validator: this.checkDurationMinutes, trigger: ['change', 'blur'] }
    ]
  }
  public scoreLevel = 0
  public examTypeList = []
  public subjectTypeList = SUBJECT_TYPE_LIST

  public groupForm = {
    groupName: ''
  }
  public rangepicker = rangepicker
  public moment = moment
  private labelCol = labelCol
  private wrapperCol = wrapperCol
  private schools = []
  private dataSource = LEVEL_1
  private columns = COlUMNS
  // 弹窗是否可见
  private groupVisible = false
  private schoolsData = []
  private paper = {}
  private paperName = ''
  private score = ''
  private schoolGroupIds = []
  private spinning = false
  // 已经上传的文件列表（受控）
  private fileList: any[] = []
  private ossClient: any = null
  private folder: any = null

  private get teacherRoles() {
    return true
  }
  private get subject(): any {
    return this.$route.query.subject && String(this.$route.query.subject).toUpperCase()
  }
  private get subjectId() {
    return this.$route.query.subject_id
  }
  private get paperID() {
    return this.$route.query.pid
  }
  private get source() {
    return this.$route.query.s
  }
  private get examId() {
    return this.$route.query.exam
  }
  private get tid() {
    return this.$route.query.tid
  }
  private get f() {
    return this.$route.query.f ? decodeURIComponent(String(this.$route.query.f)) : ''
  }
  private get supportSubjects() {
    return this.$store.state.supportSubjects || []
  }
  // 上传的试卷的地址
  private get address() {
    return this.$route.query.a ? decodeURIComponent(String(this.$route.query.a)) : ''
  }
  // 上传的试卷名称
  private get fileName() {
    return this.$route.query.a ? decodeURIComponent(String(this.$route.query.fn)) : ''
  }
  private get titleText() {
    return this.$store.state.user_info && this.$store.state.user_info.regions && this.$store.state.user_info.regions.length &&
    this.$store.state.user_info.regions[2].code == 310112 ? '练习' : '测评'
  }
  // 从测评列表过来的都是编辑
  private get isEdit() {
    if (this.f === '测评列表') {
      return true
    } else {
      return false
    }
  }
  // 题型是否可用
  private get disabled() {
    if (this.isEdit) {
      if (this.form.paperInfo.paperURL) {
        return false
      } else {
        return true
      }
    } else {
      if (this.form.paperUrl) {
        return false
      } else {
        return true
      }
    }
  }
  // 上传试卷的测评的编辑
  private get uploadFileEdit() {
    if (this.isEdit) {
      if (this.form.paperInfo.paperURL) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
  // 获取班级测评列表
  private get clazzLevelList() {
    const subjectLeaderList = this.supportSubjects
    if (this.subject) {
      const CSubject = subjectLeaderList.find((m) => {
        return m.nick === this.subject
      })
      return CSubject && CSubject.clazzLevels
    }
    return []
  }
  private get assessmentType() {
    return this.$route.meta && this.$route.meta.section
  }
  // mount
  public mounted() {
    this.getBaseInfo()
    if (this.examId) {
      this.getExamInfo(this.examId)
    } else {
      if (!this.address) {
        this.getPublishEdit()
      }
    }
    this.getOssToken()
  }
  public async getExamInfo(examId) {
    const data: any = await getExamInfo({ examId })
    if (data.success) {
      this.form.subjectTypes = data.data.contentTypes && data.data.contentTypes.split(',')
      this.form.examType = data.data.examType
      this.score = data.data.fullScore
      this.form.clazzLevel = data.data.clazzLevel
      this.form.durationMinutes = data.data.durationMinutes
      this.form.examEndTime = data.data.examEndTime
      // 测评名称的默认值是试卷名
      this.form.examName = data.data.examName ? data.data.examName : data.data.paperInfo.paperName
      this.form.examStartTime = data.data.examStartTime
      this.form.gradeType = data.data.gradeType
      this.form.oralRepeatCount = data.data.oralRepeatCount
      this.form.paperInfo = data.data.paperInfo
      this.dataSource = data.data.ranks.map((item, index) => {
        item.key = index
        return item
      })
      this.form.resultIssueTime = data.data.resultIssueTime
      this.form.studentVisible = data.data.studentVisible
      this.form.range = [data.data.examStartTime, data.data.examEndTime]
      this.form.correctStopTime = data.data.correctStopTime
      this.paperName = data.data.paperInfo.paperName
      // 获取文件信息
      this.form.paperUrl = data.data.paperUrl
      this.form.fileName = data.data.fileName
      // 对应考务状态
      this.form.newExamStatus = data.data.newExamStatus
    }
  }
  public async getBaseInfo() {
    const data: any = await getBaseInfo({})
    if (data.success) {
      this.examTypeList = data.examTypeList
    }
  }
  // 获取弹窗容器
  public getPopupContainer() {
    return document.getElementById('publish')
  }
  // 添加分组
  public addGroup(): void {
    this.groupVisible = true
  }
  public cancelGroupmodal(): void {
    this.groupVisible = false
  }
  public editGroup(): void {
    this.groupVisible = true
  }
  public delGroup(): void {}
  public onGroupSave(): void {}
  public async getPublishEdit() {
    let params: any = {
      paperId: this.paperID,
      paperSource: this.source
    }
    if (this.tid) {
      params = {
        id: this.tid
      }
    }
    const data: any = await getPublishEdit(params)
    if (data.success) {
      this.form.subjectTypes = data.data.contentTypes
      this.form.examType = data.data.useType
      this.form.paperInfo = data.data.paperInfo
      this.paper = data.data.paperInfo
      this.paperName = data.data.paperName
      // 测评默认你使用试卷名称
      this.form.examName = data.data.examName ? data.data.examName : data.data.paperName
      this.score = data.data.paperInfo.totalScore || data.data.score
      this.schoolGroupIds = data.data.schoolGroupIds
      // 未发布的编辑
      if (this.tid) {
        this.scoreLevel = data.data.rankType
        this.form.clazzLevel = data.data.clazzLevel
        this.form.durationMinutes = data.data.durationMinutes
        this.form.examEndTime = data.data.examEndTime
        this.form.examName = data.data.examName
        this.form.examStartTime = data.data.examStartTime
        this.form.gradeType = data.data.gradeType
        this.form.oralRepeatCount = data.data.oralRepeatCount
        this.form.paperInfo = data.data.paperInfo
        this.dataSource = data.data.ranks.map((item, index) => {
          item.key = index
          return item
        })
        this.form.resultIssueTime = data.data.resultIssueTime
        this.form.studentVisible = data.data.studentVisible
        this.form.range = [data.data.examStartTime, data.data.examEndTime]
        this.form.correctStopTime = data.data.correctStopTime
        this.paperName = data.data.paperInfo.paperName
        this.form.paperUrl = data.data.paperInfo.paperURL
        this.form.fileName = data.data.paperInfo.fileName

      }
    } else {
      // 提示报错
      this.$message.error(data.error)
    }
  }
  public async publishAssessment(examId) {
    const extra = {
      subject: this.subject,
      examStartTime: this.form.range[0] ? moment(this.form.range[0]).format(dateFormat) : '',
      examEndTime: this.form.range[1] ? moment(this.form.range[1]).format(dateFormat) : '',
      rankType: this.scoreLevel,
      ranks: JSON.stringify(this.dataSource),
      resultIssueTime: this.form.resultIssueTime
        ? moment(this.form.resultIssueTime).format(dateFormat)
        : '',
      correctStopTime: this.form.correctStopTime
        ? moment(this.form.correctStopTime).format(dateFormat)
        : '',
      examName: this.form.examName,
      clazzLevel: this.form.clazzLevel,
      paperInfo: this.form.paperInfo,
      paperId: this.form.paperInfo.paperId,
      studentVisible: this.form.studentVisible,
      gradeType: this.form.gradeType,
      examType: this.form.examType,
      schoolGroupIds: this.schoolGroupIds,
      oralRepeatCount: this.form.oralRepeatCount,
      paperSource: this.source,
      durationMinutes: this.form.durationMinutes,
      examId: examId ? examId : undefined,
      fullScore: this.score,
      contentTypes: this.form.subjectTypes.join(','),
      paperUrl: this.form.paperUrl || undefined,
      fileName: this.form.fileName || this.form.paperInfo.paperName
    }
    const params = { data: JSON.stringify(extra) }
    const h = this.$createElement
    this.spinning = true
    try {
      // 保存至修改
      const data: any = await publishAssessment(params)
      const self = this
      if (data.success) {
        this.trackSuccessMethod('发布成功', examId)
        this.trackEditDone({ Assessment_id: examId }) // 新增发布成功id采集
        const modal: any = this.$success({
          title: `${this.titleText}创建完成`,
          content: h('div', {}, [
            h('div', '学生可以在APP里进行查看和作答了'),
            h('div', `您可以在我的${this.titleText}-${this.titleText}列表中查看${this.titleText}详情`)
          ]),
          okText: `查看${this.titleText}列表`,
          onOk: () => {
            modal.destroy()
            this.$router.replace({ path: '/myassessment/list', query: { subject: this.subject } })
          },
          onCancel() {
            modal.destroy()
          }
        })
      } else {
        this.$message.error(data.info)
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.spinning = false
    }
  }
  public async postPublishEdit(TYPE) {
    let paperInfo: any = {}
    let score = 0
    if (this.address) {
      score = Number(this.score)
      paperInfo = {
        ...this.form.paperInfo,
        paperURL: baseUri + this.form.paperUrl,
        fileName: this.form.fileName,
        totalScore: this.score
      }
    } else {
      if(this.form.paperUrl != this.form.paperInfo.paperURL){
        this.form.paperInfo.paperURL = this.form.paperUrl
        this.form.paperInfo.fileName = this.form.fileName
      }
      paperInfo = this.form.paperInfo
    }
    // if (this.uploadFileEdit) {
    //   score = Number(this.score)
    // }
    score = Number(this.score)
    const extra = {
      status: TYPE,
      subjectId: Number(this.subjectId),
      subject: this.subject,
      examStartTime: this.form.range[0] ? moment(this.form.range[0]).format(dateFormat) : '',
      examEndTime: this.form.range[1] ? moment(this.form.range[1]).format(dateFormat) : '',
      rankType: this.scoreLevel,
      ranks: this.dataSource,
      resultIssueTime: this.form.resultIssueTime
        ? moment(this.form.resultIssueTime).format(dateFormat)
        : '',
      correctStopTime: this.form.correctStopTime
        ? moment(this.form.correctStopTime).format(dateFormat)
        : '',
      examName: this.form.examName,
      clazzLevel: this.form.clazzLevel,
      paperInfo,
      studentVisible: this.form.studentVisible,
      gradeType: this.form.gradeType,
      useType: this.form.examType,
      schoolGroupIds: this.schoolGroupIds,
      oralRepeatCount: this.form.oralRepeatCount,
      paperSource: this.source,
      durationMinutes: this.form.durationMinutes,
      id: this.tid ? this.tid : undefined,
      score,
      contentTypes: this.form.subjectTypes,
      examType
    }
    const params = { ...extra }
    // 保存至修改
    this.spinning = true
    try {
      const data: any = await postPublishEdit(params)
      const h = this.$createElement
      if (data.success) {
        const examId = data.data.examId
        if (TYPE === 'RAW') {
          this.trackSuccessMethod('保存成功', undefined)
          const modal: any = this.$success({
            title: '已保存',
            content: h('div', {}, [h('div', `您可以在我的${this.titleText}-${this.titleText}列表中查看${this.titleText}详情`)]),
            okText: `查看${this.titleText}列表`,
            onOk: () => {
              modal.destroy()
              this.$router.replace({
                path: '/myassessment/list',
                query: { subject: this.subject, pb: '1' }
              })
            },
            onCancel: () => {
              modal.destroy()
            }
          })
        } else {
          this.trackSuccessMethod('发布成功', examId)
          this.trackEditDone({ Assessment_id: examId })
          const modal: any = this.$success({
            title: `${this.titleText}创建完成`,
            content: h('div', {}, [
              h('div', '学生可以在APP里进行查看和作答了'),
              h('div', `您可以在我的${this.titleText}-${this.titleText}列表中查看${this.titleText}详情`)
            ]),
            okText: `查看${this.titleText}列表`,
            onOk: () => {
              modal.destroy()
              this.$router.replace({ path: '/myassessment/list', query: { subject: this.subject } })
            },
            onCancel: () => {
              modal.destroy()
            }
          })
        }
      } else {
        this.$message.error(data.error)
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.spinning = false
    }
  }
  // 点击发布、保存至测评列表
  public trackReleaseMethod(buttonName) {
    const exam: any = this.examTypeList.find(
      (item: { type: string; typeName: string }) => item.type === this.form.examType
    )
    const item = this.subjectTypeList.map((n) => {
      for (let m of this.form.subjectTypes) {
        if (m === n.type) {
          return n && n.typeName
        }
      }
    })
    const Grade: any = this.clazzLevelList.find((n: any) => n.level == this.form.clazzLevel)
    const assessmentSubject = this.supportSubjects.find((item) => item.nick === this.subject)
    this.trackRelease({
      buttonName,
      proSource: this.f,
      Assessment_subject: assessmentSubject && assessmentSubject.label,
      type: exam && exam.typeName,
      item: item.join(','),
      Grade: Grade && Grade.levelName,
      time: this.form.durationMinutes,
      scoreType: this.form.gradeType == 1 ? '等第制' : '分数制',
      Assessment_type: this.assessmentType // 测评类型
    })
  }
  // 保存成功、发布成功
  public trackSuccessMethod(result, examId?) {
    const exam: any = this.examTypeList.find(
      (item: { type: string; typeName: string }) => item.type === this.form.examType
    )
    const item = this.subjectTypeList.map((n) => {
      for (let m of this.form.subjectTypes) {
        if (m === n.type) {
          return n && n.typeName
        }
      }
    })
    const Grade: any = this.clazzLevelList.find((n: any) => n.level == this.form.clazzLevel)
    const assessmentSubject = this.supportSubjects.find((item) => item.nick === this.subject)
    this.trackSuccess({
      result,
      proSource: this.f,
      Assessment_subject: assessmentSubject && assessmentSubject.label,
      type: exam && exam.typeName,
      item: item.join(','),
      Grade: Grade && Grade.levelName,
      time: this.form.durationMinutes,
      scoreType: this.form.gradeType == 1 ? '等第制' : '分数制',
      // 新增测评id选项
      Assessment_id: examId,
      Assessment_type: this.assessmentType
    })
  }
  // 发布
  public onSubmit(): void {
    if (isNaN(Number(this.score)) || Number(this.score)<=0) {
      this.$message.error('试卷满分必须要大于0')
      return;
    }
    this.trackReleaseMethod('发布')
    const refs: any = this.$refs
    refs.ruleForm.validate((valid) => {
      if (valid) {
        if (this.tid) {
          this.getExamStatus(this.tid)
        } else {
          this.postPublishEdit('ONLINE')
        }
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }
  public onSubmitMain() {
    this.trackReleaseMethod('发布')
    const refs: any = this.$refs
    refs.ruleForm.validate((valid) => {
      if (valid) {
        this.publishAssessment(this.examId)
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }
  // 保存
  public save(): void {
    if (isNaN(Number(this.score)) || Number(this.score)<=0) {
      this.$message.error('试卷满分必须要大于0')
      return;
    }
    this.trackReleaseMethod('保存至测评列表')
    const refs: any = this.$refs
    refs.ruleForm.validate((valid) => {
      if (valid) {
        this.postPublishEdit('RAW')
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }
  // 返回上级页面
  public back(): void {
    if (this.source === 'PERSONAL_ASSESSMENT') {
      if (this.ROUTER_FROM && this.ROUTER_FROM.path) {
        if (this.ROUTER_FROM.path === '/testpreview') {
          this.$router.push({ path: '/assessment' })
        } else {
          this.$router.back()
        }
      } else {
        this.$router.push({ path: '/assessment' })
      }
    } else {
      this.$router.back()
    }
  }
  // 选择不同的分数制度
  public onRanksChange() {
    switch (this.scoreLevel + 1) {
      case 1:
        this.dataSource = LEVEL_1
        break
      case 2:
        this.dataSource = LEVEL_2
        break
      case 3:
        this.dataSource = LEVEL_3
        break
      default:
        this.dataSource = LEVEL_1
        break
    }
  }
  // getExamStatus
  public async getExamStatus(id) {
    try {
      const data: any = await getExamStatus({ id })
      if (data.success) {
        if (data.data.status === 'RAW') {
          this.postPublishEdit('ONLINE')
        } else {
          this.publishAssessment(data.data.examId)
        }
      }
    } catch (e) {
      console.log(e)
    }
  }
  //
  public range(start, end) {
    const result: any[] = []
    for (let i = start; i < end; i++) {
      result.push(i)
    }
    return result
  }
  // 设置日期range插件禁用日期
  public disabledRangeDate(current) {
    if (this.form.examStartTime) {
      return current && current < moment(this.form.examStartTime, 'YYYY-MM-DD')
    } else {
      // 如果是上传的试卷，需要t+7的限制
      if (this.form.paperUrl) {
        return current && current < moment().add(7, 'days')
      } else {
        return current && current < moment().add(0, 'days')
      }
    }
  }
  // 设置时间range插件禁用时间
  public disabledRangeTime(_, type) {
    // if (this.form.examStartTime) {
    //   let hour = moment(this.form.examStartTime).hours()
    //   let minute = moment(this.form.examStartTime).minutes()
    //   return {
    //     disabledHours: () => this.range(0, hour),
    //     disabledMinutes: () => this.range(0, minute)
    //   }
    // }
  }
  // 设置成绩发布时间
  public disabledScoreDate(current) {
    if (this.form.paperUrl) {
      return current && current < moment().add(8, 'days')
    } else {
      return current && current < moment().add(1, 'days')
    }
  }
  // 成绩修订时间
  public disabledCorrectDate(current) {
    if (this.form.paperUrl) {
      return current && current < moment().add(7, 'days')
    } else {
      return current && current < moment().add(0, 'days')
    }
  }
  // 校验 datetime-picker ，后面文案可以单独抽离出来，存放在一个配置文件中
  public checkDateRange(rule, value, callback) {
    if (value && value.length > 0) {
      const [start, end] = value.map((item) => moment(item))
      const minutes = end.diff(start, 'minutes')
      // 用时间区间差值与答题总时长进行比对，
      if (minutes >= Number(this.form.durationMinutes)) {
        callback()
      } else {
        callback(`${this.titleText}截止时间”不能早于“${this.titleText}开始时间”+“答题时长`)
      }
    } else {
      if (this.form.paperUrl) {
        callback(`请选择${this.titleText}开始时间和${this.titleText}结束时间， ${this.titleText}最早开始时间在当前日期的T+7个工作日`)
      } else {
        callback(`请选择${this.titleText}开始时间和${this.titleText}结束时间， ${this.titleText}最早开始时间在当前日期的T+1个工作日`)
      }
    }
  }
  // 校验教师修改截止时间
  public checkCorrectTime(rule, value, callback) {
    // start 在 end 之后
    const end: any = moment(this.form.range[1])
    const start: any = moment(this.form.resultIssueTime)
    // value 分别与 成绩发布时间 测评结束时间 比对
    const diffWithEnd = end.diff(value, 'seconds')
    const diffWithStart = start.diff(value, 'seconds')
    if (value) {
      // 首先判断是否有成绩发布时间，如果有，需要比对; 如果还没有则优先填写教师修改截止时间, 先不考虑上限，只要考虑大于end即可。
      if (start && start._isValid) {
        if (diffWithEnd && diffWithStart && diffWithEnd < 0 && diffWithStart > 0) {
          callback()
        } else {
          callback('教师修订成绩截止时间必须在测评结束时间和成绩发布时间之间')
        }
      } else {
        if (diffWithEnd && diffWithEnd < 0) {
          callback()
        } else {
          callback('教师修订成绩截止时间必须在测评结束时间和成绩发布时间之间')
        }
      }
    } else {
      callback('请选择修订成绩截止时间，教师修订成绩截止时间必须在测评结束时间和成绩发布时间之间')
    }
  }
  // 校验成绩发布时间
  public checkPublishTime(rule, value, callback) {
    const end = moment(this.form.range[1])
    // 设置时间到明天早上6点
    const tomorrow = moment(end)
      .subtract(-1, 'days')
      .hours(6)
      .minutes(0)
      .seconds(0)
    const diffWithTomorrow = tomorrow.diff(value, 'seconds')
    // 如果教师最终修改时间已经设定，那么成绩发布时间需要在教师批改截止时间之后
    const correctTime: any = moment(this.form.correctStopTime)
    const diffWithCorrectTime = correctTime.diff(value, 'seconds')
    const diffEndWithCorrectTime: any = end.diff(correctTime, 'seconds')
    const diffTomorrowWithCorrectTime: any = tomorrow.diff(correctTime, 'seconds')
    if (value) {
      // 先判定是否已有批改截止时间 如果有批改时间，批改时间是否填写正确
      if (correctTime && correctTime._isValid) {
        // 批改时间大于评测时间且大于评测时间第二天6点
        if (diffEndWithCorrectTime <= 0 && diffTomorrowWithCorrectTime <= 0) {
          if (diffWithCorrectTime <= 0) {
            callback()
          } else {
            callback(
              '成绩发布时间最早在测评结束时间第二天的 06:00，且成绩发布时间需晚于教师修订成绩截止时间'
            )
          }
          callback()
        } else {
          if (diffWithTomorrow <= 0) {
            callback()
          } else {
            callback('成绩发布时间最早在测评结束时间第二天的 06:00')
          }
        }
      } else {
        if (diffWithTomorrow <= 0) {
          callback()
        } else {
          callback('成绩发布时间最早在测评结束时间第二天的 06:00')
        }
      }
    } else {
      callback('请选择成绩发布时间，最早在测评结束时间第二天的 06:00')
    }
  }
  // 校验试卷答题总时长
  public checkDurationMinutes(rule, value, callback) {
    if (value) {
      const [start, end] = this.form.range.map((item) => moment(item))
      const minutes = end.diff(start, 'minutes')
      // 比较答题时长与测评开始、结束时间的差值
      if (value > minutes) {
        callback('试卷总答题时长需小于测评结束时间-测评开始时间')
      } else {
        callback()
      }
    } else {
      callback('请填写答题时长')
    }
  }
  public async getOssToken() {
    const data: any = await getOssToken()
    if (data && Object.keys(data).length > 0) {
      const client = new OSS({
        region: data.Region,
        accessKeyId: data.AccessKeyId,
        accessKeySecret: data.AccessKeySecret,
        stsToken: data.SecurityToken,
        bucket: data.Bucket
      })
      this.ossClient = client
      this.folder = data.Folder
    }
  }
  public uploadFile(file: any) {
    const self = this
    Promise.all([this.ossClient, getMd5(file)]).then(async ([oss, md5]: Array<any>) => {
      const originalFileName = file.name || ''
      let surfix = ''
      console.log(originalFileName)
      if (originalFileName.indexOf('.') > -1) {
        surfix = originalFileName.split('.').pop()
      }
      const newName = this.folder + (surfix ? `${md5}.${surfix}` : md5)
      const newUploadingItem = {
        file,
        client: oss,
        tempCheckpoint: undefined,
        filename: newName,
        // 其他
        name: originalFileName
      }
      uploadAliyunOss(newUploadingItem).then(() => {
        // 上传成功之后回调
        this.fileList = [{ url: prefix + newName, name: newUploadingItem.name }]
        this.form.paperUrl = this.fileList[0].url
        this.form.fileName = this.fileList[0].name
        this.$message.success('试卷上传成功')
      })
    })
  }
  public customRequest(action){
    const file = action.file
    console.log(file)
    try {
      this.uploadFile(file)
    } catch (e) {
      console.log(e)
    }
    window['sensors'].track('TIKU_Assessment_uploading_again', { buttonName: '重新上传' })
  }
  public handleChange(){}
}
